<template>
    <b-modal size="xl" button-size="sm" v-model="showModal" :title="title" hide-footer @hidden="cancelar">
        <div class="modal-body">
            <b-card bg-variant="light">
                <b-form @submit.prevent="handleSubmit">
                    <b-row class="justify-content-center">
                        <b-col cols="8" >
                            <lg-form-input id="searchText" label=" " v-model="searchText" />
                        </b-col>
                        <b-col cols="auto" class="d-flex align-items-center">
                            <b-button id="procurarOperacaoIBP" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill
                                variant="primary" @click="load">
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="search" />
                                </div>
                                <b-tooltip target="procurarOperacaoIBP" title="Localizar" triggers="hover focus"></b-tooltip>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </b-card>
            <b-card bg-variant="light">
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" show-empty>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>
                </b-table>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        Página {{ page }} de {{ totalPage }} - {{ total }} registros
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </div>
    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { ListResourceMixin } from "@/core/mixins/resource"
import moment from 'moment'

export default {
    components: {
        LgFormInput,
    },
    props: {
        prefix: Array,
        id: Number,
    },
    data() {
        return {
            showModal: true,
            searchText: "",
            busy: false,
        }
    },
    mounted() {
        this.load()
    },
    mixins: [ListResourceMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/operacaoitembempermanente`)
    },
    watch: {
        page() {
            this.load()
        },
    },

    computed: {
        updatedPrefix() {
            return [...this.prefix, "Operações IBP"]
        },
        title() {
            return this.updatedPrefix.join(" > ")
        },
        tableFields() {
            return [
                {
                    key: "data", label: "Data", formatter: (value) => {
                        return moment(value).format('DD/MM/YYYY')
                    }, tdClass: "px-2"
                },
                { key: "tipoOperacao.descricao", label: "Tipo de Operação", tdClass: "px-2" },
                { key: "descricao", label: "Descrição", tdClass: "px-2" },
            ]
        },
    },
    methods: {
        handleSubmit(event) {
            event.preventDefault()
            this.load()
        },
        async load() {
            this.busy = true
            var filtro = {}
            if (this.id) {
                filtro.id = this.id
            }
            if (this.searchText) {
                filtro.pesquisaOperacao = this.searchText
            }

            await this.$loadResource({
                limit: this.perPage,
                page: this.page,
                params: filtro,
            })
            this.busy = false
        },
        cancelar() {
            this.$emit("close")
        },
    },
}
</script>
<style scoped>
.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-body {
    padding-top: 1rem;
}
</style>